import { useTranslation } from "react-i18next";

const Translate = ({ children }) => {
  const { t } = useTranslation();

  return typeof children === "string" ? t(children) : children;
};

export default Translate;
